import { Process } from '@ov-suite/helpers-shared';
import gql from 'graphql-tag';

export function startProcessInstanceByKeyMutation(keys: (keyof Process)[]) {
  return gql(`mutation StartProcessInstanceByKey($query:StartProcessByKeyInput!) {
    startProcessInstanceByKey(query: $query) {
       ${keys.join(`\n`)}
     }
   }`);
}

// todo: Complete this
export function startWorkflowMutation() {
  return gql(`
    mutation StartProcess($params: StartProcessInput!) {
      startProcess(params: $params) {
        id
        taskIds
      }
    }
  `);
}
